import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Bundles a role into a department. The request body is the raw role uid (matching the API's
 * `[FromBody] Guid roleUid` contract), not a wrapped object.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the department.
 * @param roleUid - Unique identifier of the role to bundle.
 * @returns OperationResult (no payload).
 */
export const upsertDepartmentRole = async (instance: KyInstance, uid: string, roleUid: string) => {
  try {
    return await instance
      .post<OperationResult>(formatString(Uri.departments.roles, uid), {
        json: roleUid,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
